module.exports = __webpack_public_path__ + "img/cornering_left.ee57aea1.svg";